<template>
  <div
    class="button d-flex justify-content-center align-items-center px-3 py-input my-2"
    @click="$emit('click')"
  >
    <Icon icon="icon-facebook" :width="25" :height="25" color="white" class="mr-1" />
    <span v-if="login"
      >{{ $t('profile.logIn.main.logInWith') }} <span class="font-weight-bold">facebook</span></span
    >
    <span v-else
      >{{ $t('profile.signUp.main.signUpWith') }}
      <span class="font-weight-bold">facebook</span></span
    >
  </div>
</template>

<script>
import Icon from 'UI/Icon';
export default {
  components: {
    Icon
  },
  props: {
    login: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.button {
  cursor: pointer;
  color: white;
  border-radius: 30px;
  background-color: #4072fb;
  span {
    font-size: 12px;
    min-width: 130px;
    white-space: nowrap;
  }
}
</style>
